/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Api_Errors_Class_Already_ExistsInputs */

const nl_import_api_errors_class_already_exists = /** @type {(inputs: Import_Api_Errors_Class_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een of meerdere klassen bestaan al`)
};

/**

* @param {Import_Api_Errors_Class_Already_ExistsInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const import_api_errors_class_already_exists = /** @type {((inputs?: Import_Api_Errors_Class_Already_ExistsInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Api_Errors_Class_Already_ExistsInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_import_api_errors_class_already_exists(inputs)
});
export { import_api_errors_class_already_exists as "import.api_errors.class_already_exists" }